import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Badge from '../../common/base/Badge';
import Button from '../../common/base/Button';
import Container from '../../common/base/Container';
import Icon from '../../common/base/Icon';
import Text from '../../common/base/Text';
import { Div } from '../../common/helpers/StyledUtils';
import { StyledViewContent, StyledViewLayout } from '../../layouts/ViewLayout';
const NotFound: React.FC<{
  id: string;
  title: string;
  description: string;
  link?: {
    to: string;
    text: string;
  };
  extra_action?: React.ReactNode;
}> = t0 => {
  const $ = _c(18);
  const {
    id,
    title,
    description,
    link,
    extra_action
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "center",
      justify: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon muted={true} large={true} icon="plagiarism" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      t: 4
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <Text bold={true} m={t3} center={true} size="l">{title}</Text>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      t: 1
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== description) {
    t6 = <Text muted={true} as="p" m={t5}>{description}</Text>;
    $[6] = description;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== id) {
    t7 = id && <Badge m={{
      t: 1
    }} neutral={true}>{id}</Badge>;
    $[8] = id;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== extra_action || $[11] !== link) {
    t8 = link && <Div flex={{
      gap: 2,
      justify: "center"
    }} m={{
      t: 8
    }}><Button primary={true} ghost={true} to={link.to}>{link.text} {"->"}</Button>{extra_action}</Div>;
    $[10] = extra_action;
    $[11] = link;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <StyledViewLayout><StyledViewContent><Container small={true} center={true} h={100} flex={t1}><Div>{t2}{t4}{t6}{t7}{t8}</Div></Container></StyledViewContent></StyledViewLayout>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default NotFound;